// extracted by mini-css-extract-plugin
export default {"head":"List_head__Z4zAH","headMain":"List_headMain__I9NXF","pad0":"List_pad0__J7et9","btntbl":"List_btntbl__0TTom","id":"List_id__4n2u0","btns":"List_btns__kk0wu"};